function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  className: "nc-icon-wrapper",
  fill: "#fff"
}, React.createElement("path", {
  "data-color": "color-2",
  d: "M17,5h-3v2h3c2.757,0,5,2.243,5,5s-2.243,5-5,5v-3l-5,4l5,4v-3c3.86,0,7-3.141,7-7 S20.86,5,17,5z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M2,12c0-2.757,2.243-5,5-5v3l5-4L7,2v3c-3.86,0-7,3.141-7,7s3.14,7,7,7h3v-2H7C4.243,17,2,14.757,2,12z"
}));

var SvgCycle = function SvgCycle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCycle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cycle.0913e364.svg";
export { ForwardRef as ReactComponent };